import $http from '@/api/index';
import store from '@/store';

export default {
  async getTwitterAuthUrl(appId) {
    const context = store.getters.context;
    return $http.post(`/api/social-network/app/twitter/${appId}/auth/url`, { context });
  },
  async getFacebookAuthUrl(appId) {
    const context = store.getters.context;
    return $http.post(`/api/social-network/app/facebook/${appId}/auth/url`, { context });
  },
};
